import { AppDispatch } from "../../../store";

export const getPromiseAllArray = (arr: any, dispatch: AppDispatch) => {
  const array = Promise.all(arr.map((item: any) => dispatch(item)));
  return array;
};
